import * as Dialog from '@radix-ui/react-dialog'

import { FxButton } from '@/components/fx'

/**
 * The dialog skin the cockpit already uses (see `CockpitHeader`), in its own
 * file because this tab opens four of them. Radix carries the focus trap,
 * Escape, the labelled title and the return of focus to whatever opened it.
 */
export function DialogShell({
  open,
  onClose,
  title,
  description,
  children,
}: {
  open: boolean
  onClose: () => void
  title: string
  description?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-[#0000008c]" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(520px,calc(100vw-40px))] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-surface p-5 shadow-overlay xs:p-8">
          <Dialog.Title className="mb-4 text-dialog-title text-text">{title}</Dialog.Title>
          {description != null && (
            <Dialog.Description asChild>
              <div className="mb-6 text-body text-text">{description}</div>
            </Dialog.Description>
          )}
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

/**
 * A yes/no dialog. `error` stays inside it rather than becoming a toast: the
 * refusals on this screen ("noch auf 2 Layouts platziert") are the answer to
 * the question the dialog asked, and belong where the question is.
 */
export function ConfirmDialog({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  danger = true,
  pending,
  error,
  onConfirm,
}: {
  open: boolean
  onClose: () => void
  title: string
  description: React.ReactNode
  confirmLabel: string
  danger?: boolean
  pending?: boolean
  error?: string | null
  onConfirm: () => void
}) {
  return (
    <DialogShell open={open} onClose={onClose} title={title} description={description}>
      {error && (
        <p role="alert" className="mb-4 text-body text-danger-text">
          {error}
        </p>
      )}
      <div className="flex flex-wrap justify-end gap-3">
        <FxButton variant="outlined" onClick={onClose}>
          Abbrechen
        </FxButton>
        <FxButton variant={danger ? 'danger' : 'primary'} disabled={pending} onClick={onConfirm}>
          {confirmLabel}
        </FxButton>
      </div>
    </DialogShell>
  )
}
